import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a6ad6c5a875aa0014d12bfa_1788546365807_81acb3de/trek_1785386693200/src/app/discover/page.tsx");
